<div class="container">
    <header class="mainarea w-container">
        <a href="https://spglobal.com" title="S&amp;P Global Market Intelligence" target="_blank" rel="noopener" i18n-title>
            <img src="{{logoLink}}" width="330" height="36" alt="" class="logo" />
        </a>
    </header>

    <router-outlet></router-outlet>
    <!-- Begin Footer File -->
    <footer class="footer_container d-flex text-light" style="margin-left: -15px; margin-right: -15px;">
        <span style="font-size: 12px;" i18n> © {{currentYear}} S&P Global. All Rights Reserved</span>
        <div class="ml-auto"></div>
        <span style="font-size: 12px;" *ngIf="isNativeLanguagePrivacyVisible" class="pr-2">
            <a class="text-light" i18n i18n-href i18n-title href="/#/privacy-notice" target="_blank">Privacy Notice</a>
        </span>
        <span style="font-size: 12px;" *ngIf="isENPrivacyVisible" class="pr-2">
            <a class="text-light" href={{apacenprivacynotice}} target="_blank">Privacy Notice</a>
        </span>
    </footer>
</div>